import { render, staticRenderFns } from "./ProviderItem.vue?vue&type=template&id=303b3bd8&scoped=true&"
import script from "./ProviderItem.vue?vue&type=script&lang=js&"
export * from "./ProviderItem.vue?vue&type=script&lang=js&"
import style0 from "./ProviderItem.vue?vue&type=style&index=0&id=303b3bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303b3bd8",
  null
  
)

export default component.exports